import { Card, CardContent } from "@/components/ui/card";

/** Compact KPI card. */
export function Stat({ label, value, accent }) {
  return (
    <Card className={`border-[#E5E7EB] ${accent ? "bg-[#1E3F33] text-[#F9F8F6]" : ""}`}>
      <CardContent className="p-6">
        <p
          className={`text-xs uppercase tracking-widest mb-2 ${
            accent ? "text-[#F9F8F6]/70" : "text-gray-500"
          }`}
        >
          {label}
        </p>
        <p
          className={`font-['Outfit'] text-3xl font-semibold ${
            accent ? "text-[#F9F8F6]" : "text-[#1E3F33]"
          }`}
        >
          {value}
        </p>
      </CardContent>
    </Card>
  );
}

/** Compact funnel stat (label + big number + small caption). */
export function FunnelStat({ label, value, caption }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">
        {label}
      </p>
      <p className="font-['Outfit'] text-3xl font-semibold text-[#1E3F33]">
        {value}
      </p>
      {caption && <p className="text-xs text-gray-500 mt-1">{caption}</p>}
    </div>
  );
}

/** Render a small human-readable duration: '32s', '4m 12s', '2h 11m', '3d 4h'. */
export function formatLeaderboardDuration(seconds) {
  if (seconds == null || seconds < 0) return "—";
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m < 60) return s ? `${m}m ${s}s` : `${m}m`;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h < 24) return mm ? `${h}h ${mm}m` : `${h}h`;
  const d = Math.floor(h / 24);
  const hh = h % 24;
  return hh ? `${d}d ${hh}h` : `${d}d`;
}
